import React from 'react';
import { useWebsiteContent } from '../../hooks/useWebsiteContent';
import { footerModel } from '../../utils/localBusiness';

const SiteFooter: React.FC = () => {
  const business = footerModel(useWebsiteContent());

  return (
    <footer className="site-footer">
      <div className="site-footer-business">
        <p className="site-footer-name">{business.name}</p>
        <p className="site-footer-place">{business.placeLine}</p>
        <p className="site-footer-contact">
          <a href={business.phoneTel}>{business.phoneDisplay}</a>
          <a href={`mailto:${business.email}`}>{business.email}</a>
          <a href={business.reviewUrl} target="_blank" rel="noopener noreferrer">{business.reviewLabel}</a>
        </p>
      </div>
      <nav className="site-footer-nav" aria-label="Footer">
        <a href="/galleries">Galleries</a>
        <a href="/blog">Blog</a>
        <a href="/about">About</a>
        <a href="/contact">Contact</a>
      </nav>
    </footer>
  );
};

export default SiteFooter;
